import type * as Sentry from '@sentry/react';

/**
 * Returns true if the error should be filtered out (dropped).
 * Accepts an optional raw stack string (from hint.originalException.stack)
 * to catch cases where processed frames don't contain the source filename.
 */
export function isFilteredSentryError(
  event: Sentry.ErrorEvent,
  rawStack?: string,
): boolean {
  const allValues = event.exception?.values ?? [];
  const allFrames = allValues.flatMap((v) => v.stacktrace?.frames ?? []);

  // Build a single searchable string from all available source info:
  // frame filenames, abs_path, module, and the raw Error.stack if provided.
  const searchable = [
    ...allFrames.flatMap((f) =>
      [f.filename, f.abs_path, f.module].filter(Boolean),
    ),
    ...(rawStack ? [rawStack] : []),
  ]
    .join('\n')
    .toLowerCase();

  // Filter all cornerstone errors
  if (searchable.includes('@cornerstonejs/core')) return true;

  // Filter specific userpilot TypeError
  if (searchable.includes('userpilot.io/sdk')) {
    const exception = allValues[0];
    const message = exception?.value ?? '';
    if (
      exception?.type === 'TypeError' &&
      message.includes(
        "Cannot read properties of undefined (reading 'display')",
      )
    )
      return true;
  }

  return false;
}
